var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForminstaWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.22,
    height: 31.222,
    viewBox: "0 0 31.22 31.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9253",
    "data-name": "Group 9253",
    transform: "translate(-1582.376 -564.595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M2272.347,171.589c4.168,0,4.662.016,6.308.09a8.641,8.641,0,0,1,2.9.538,5.156,5.156,0,0,1,2.962,2.962,8.686,8.686,0,0,1,.538,2.9c.076,1.646.09,2.14.09,6.308s-.015,4.66-.09,6.308a8.654,8.654,0,0,1-.538,2.9,5.152,5.152,0,0,1-2.962,2.964,8.641,8.641,0,0,1-2.9.538c-1.646.075-2.14.089-6.308.089s-4.662-.013-6.308-.089a8.644,8.644,0,0,1-2.9-.538,5.156,5.156,0,0,1-2.962-2.964,8.67,8.67,0,0,1-.538-2.9c-.076-1.647-.091-2.14-.091-6.308s.015-4.662.091-6.308a8.7,8.7,0,0,1,.538-2.9,5.159,5.159,0,0,1,2.962-2.962,8.645,8.645,0,0,1,2.9-.538c1.646-.074,2.14-.09,6.308-.09m0-2.814c-4.24,0-4.772.02-6.436.1a11.467,11.467,0,0,0-3.79.725,7.987,7.987,0,0,0-4.565,4.567,11.452,11.452,0,0,0-.725,3.789c-.076,1.664-.094,2.2-.094,6.436s.018,4.772.094,6.436a11.463,11.463,0,0,0,.725,3.791,7.978,7.978,0,0,0,4.565,4.565,11.465,11.465,0,0,0,3.79.725c1.664.077,2.2.094,6.436.094s4.771-.016,6.436-.094a11.469,11.469,0,0,0,3.791-.725,7.976,7.976,0,0,0,4.565-4.565,11.462,11.462,0,0,0,.726-3.791c.075-1.664.093-2.2.093-6.436s-.018-4.772-.093-6.436a11.451,11.451,0,0,0-.726-3.789,7.607,7.607,0,0,0-1.8-2.765,7.685,7.685,0,0,0-2.765-1.8,11.47,11.47,0,0,0-3.791-.725c-1.664-.075-2.2-.1-6.436-.1",
    transform: "translate(-674.361 395.82)",
    fill: "#111",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M2269.381,173.4a8.017,8.017,0,1,0,8.016,8.018,8.017,8.017,0,0,0-8.016-8.018m0,13.221a5.2,5.2,0,1,1,5.2-5.2,5.2,5.2,0,0,1-5.2,5.2",
    transform: "translate(-671.395 398.786)",
    fill: "#111",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M2273.933,173.941a1.873,1.873,0,1,1-1.874-1.872,1.875,1.875,0,0,1,1.874,1.872",
    transform: "translate(-665.741 397.931)",
    fill: "#111",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForminstaWhite);
export default __webpack_public_path__ + "static/media/forminsta-white.46d44790471039200ee0a7c8275697aa.svg";
export { ForwardRef as ReactComponent };